// extracted by mini-css-extract-plugin
export default {"results":"RoundResultsList_results__QdyXH"};